"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExpandIcon = function ExpandIcon(_ref) {
  var onClick = _ref.onClick;
  return _react2.default.createElement(
    "svg",
    {
      onClick: onClick,
      width: "28px",
      height: "28px",
      viewBox: "0 0 28 28",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink" },
    _react2.default.createElement(
      "g",
      { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
      _react2.default.createElement(
        "g",
        { transform: "translate(-498.000000, -428.000000)", stroke: "#00ADEF" },
        _react2.default.createElement(
          "g",
          { transform: "translate(499.000000, 429.000000)" },
          _react2.default.createElement("circle", { fill: "#FFFFFF", cx: "13", cy: "13", r: "13" }),
          _react2.default.createElement("polyline", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            transform: "translate(13.000000, 9.285714) rotate(-180.000000)  translate(-13.000000, -9.285714)",
            points: "16.7142857 7.42857143 12.9997277 11.1428571 9.28571429 7.42857143" }),
          _react2.default.createElement("polyline", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            points: "16.7142857 14.8571429 12.9997277 18.5714286 9.28571429 14.8571429" })
        )
      )
    )
  );
};

exports.default = ExpandIcon;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-expandable-container/dist/ExpandIcon.js
// module id = 404
// module chunks = 168707334958949